export default __webpack_public_path__ + "static/events-light-2653f4753cc393790ac49a56e34da0ee.png";